import VueCookies from 'vue-cookies'

export default {
  install (Vue) {
    Vue.use(VueCookies)
  }
}
